import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';

import PefilSellerListFilial from './ListFilial';

import {
    listarFilialSeller,
    listarFilialSellerComFiltro,
    gerarExelFilial
} from '../../../services/http/SellerAdminstradorService/filialSellerService';

import services from '../../../services';

import { trackPromise } from 'react-promise-tracker';
import { useSnackBar } from '../../../hooks/snackBar';
import { saveAs } from 'file-saver';

import './styles.scss';

const PerfilSellerFilial = ({ subSellerPage }) => {

    const history = useHistory();
    const { idSeller } = services.storage.getUser();
    const { addSnackBar } = useSnackBar();
    const [busca, setBusca] = useState('');
    const [filialResponse, setEmpresas] = useState(
        {
            numeroPagina: 0,
            totalPaginas: 0,
            lista: [],
            tamanhoPagina: 0,
            hasPreviousPage: false,
            hasNextPage: false
        });

    const CarregarListaFilial = (pagina) => {
        trackPromise(
            listarFilialSeller(pagina, idSeller)
                .then(res => {
                    if (res.data) {
                        setEmpresas(res.data);
                    } else {
                        addSnackBar({ message: 'Não foi possível carregar filiais', info: 'error', open: true });
                    }
                })
        ).catch(error => {
            addSnackBar({ message: 'Erro ano tentar carregar filiais', info: 'error', open: true });
        })
    }

    const CarregarListaFilialComFiltro = (filtro, pagina) => {
        trackPromise(
            listarFilialSellerComFiltro(idSeller, filtro, pagina)
                .then(res => {
                    if (res.data) {
                        setEmpresas(res.data);
                    } else {
                        addSnackBar({ message: 'Não foi possível carregar filiais', info: 'error', open: true });
                    }
                })
        ).catch(error => {
            addSnackBar({ message: 'Erro ano tentar carregar filiais', info: 'error', open: true });
        })
    }

    const extrairBase = () => {
        trackPromise(
            gerarExelFilial(idSeller)
                .then(res => {
                    if (res.data) {
                        saveAs(res.data, "Filiais.xlsx")

                    } else {
                        addSnackBar({ message: 'Não foi possível extrair a base com filiais', info: 'warning', open: true });
                    }
                })
        ).catch(error => {
            addSnackBar({ message: 'Erro ano extrair a base com filiais', info: 'error', open: true });
        })
    }

    const mudarPaginaFilialSeller = (page) => {
        busca != "" ? CarregarListaFilialComFiltro(busca, page) : CarregarListaFilial(page);
    }

    const buscar = (filtro) => {
        setBusca(filtro);
    }

    useEffect(() => {
        if (busca != "") {
            const delayDebounceFn = setTimeout(() => {
                CarregarListaFilialComFiltro(busca, 1);
            }, 2000)

            return () => clearTimeout(delayDebounceFn)
        } else {
            CarregarListaFilial(1);
        }

    }, [busca]);

    useEffect(() => {
        CarregarListaFilial(1)
    }, []);

    return (
        <div>
            <div className='row mt-1 ml-1 titulo'>
                Cadastro Filiais
            </div>
            <div className='row mt20  ml-1 '>
                <h1 className='label-second'>Filiais Cadastradas</h1>
            </div>

            <div className='row'>
                <div className='col-sm-3 col-md-3 col-lg-3'>
                    <button onClick={() => history.push("/seller/filial/cadastro")} className="buton-green btn btn-block btn-lg mt20">
                        CADASTRAR FILIAL
                    </button>
                </div>

                <div className='col-sm-3 col-md-3 col-lg-3'>
                    <button className="buton-white-black-border btn btn-block btn-lg mt20" onClick={extrairBase}>
                        EXTRAIR BASE
                    </button>
                </div>
            </div>
            <PefilSellerListFilial
                response={filialResponse}
                mudarPagina={mudarPaginaFilialSeller}
                buscar={buscar}
                busca={busca}
            />

        </div>
    );
}

export default PerfilSellerFilial;